/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import 'react-app-polyfill/ie11'
import React from 'react'
import ReactDOM from 'react-dom'
import { HashRouter } from 'react-router-dom'
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import { createLogger } from 'redux-logger'
import createSagaMiddleware, { END } from 'redux-saga'
import { ConnectedRouter, routerMiddleware } from 'connected-react-router/immutable'
import rootReducer, { history } from './store'
import rootSaga from './sagas'
import App from './App'

import '@ant-design/compatible/assets/index.css'
import './index.css'

const sagaMiddleware = createSagaMiddleware()
const middleware = [sagaMiddleware, routerMiddleware(history)]

if (process.env.NODE_ENV === 'development') {
  middleware.push(
    createLogger({
      collapsed: true,
      stateTransformer: (state: { toJS: any }) => state.toJS()
    })
  )
}

const composeEnhancers =
  process.env.NODE_ENV === 'development' && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose

const enhancer = composeEnhancers(
  applyMiddleware(...middleware)
  // other store enhancers if any
)

let store: any = null
store = createStore(rootReducer, enhancer)
sagaMiddleware.run(rootSaga)
store.close = () => store.dispatch(END)

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <HashRouter>
        <App />
      </HashRouter>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
)
// React.StrictMode
/*  </AntdConfigProvider> */
